<template>
	<div class="user_prof d-flex flex-column" >
        <div class="mb-3" >
            <button type="button" class="btn btn-outline-success btn-lg btn-block waves-effect waves-themed" v-on:click.stop="go_profile">
                PROFILE
            </button>
        </div>

		<div class="mb-3">
			<button  v-on:click.stop="logout" type="submit" class="btn btn-outline-danger btn-lg btn-block waves-effect waves-themed">
				EXIT
			</button>
		</div>
	</div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
	getterType: 'user/getUserField',
	mutationType: 'user/updateUserField',
});

export default {
	name: "user_buttons",
	created () {
		EventBus.$on('user_added',this.get_params)
	},

	data() {
		return {
			is_auth: false,
			show: true,
		}
	},
	methods : {
		get_params() {

		},
		go_profile() {
			window.location.href = "/user/profile";
		},
		async logout() {
			await api.post('/logout').then(({data}) => {
				window.location.reload();
			});

		}

	},
	computed : {
		...mapFields([
			'user'
		]),
	}

	}
</script>

<style scoped>

</style>
